import React, { useCallback, useState } from 'react';
import { Box, Button } from '@rsos/components/capstone/base';
import { StartMessage, StartMessageContainer } from './TF911.styles';

const BTN_SIZE = 40;

const TF911StartMessage = ({
  isCreatingConversation,
  message,
  onSendMessageClick,
}) => {
  const [showSendButton, setShowSendButton] = useState(false);
  const handleMouseEnter = useCallback(() => {
    setShowSendButton(true);
  }, []);
  const handleMouseLeave = useCallback(() => {
    setShowSendButton(false);
  }, []);
  return (
    <StartMessageContainer
      align="center"
      horizontal
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      justify="space-between"
      py="12px"
      px="16px"
    >
      <Box width={`calc(100% - ${BTN_SIZE}px)`}>
        <StartMessage>"{message}"</StartMessage>
      </Box>

      {showSendButton && (
        <Button
          disabled={isCreatingConversation}
          isLoadingProp={isCreatingConversation}
          size="xxsmall"
          btnType="tertiary"
          noMargin
          onClick={() => onSendMessageClick(message)}
          // width={`${BTN_SIZE}px`}
        >
          Send
        </Button>
      )}
    </StartMessageContainer>
  );
};

export default TF911StartMessage;
